<template>
  <div class="w-100 tiptap-format">
    <div v-if="editing && !readOnly" v-click-outside="handleClickOutside">
      <div>
        <slot name="form"></slot>
      </div>
      <div v-if="buttons" class="d-flex justify-content-end mx-3 mt-1">
        <slot name="buttons"></slot>
        <h-b-action-rounded size="sm" class="ml-2" icon="bx bx-check" @click.native="handleSubmit"></h-b-action-rounded>
      </div>
    </div>
    <div v-else :class="{ 'cursor-pointer': !readOnly }" @click="turnEditing">
      <slot name="visualize"></slot>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'field-visualize',

  directives: {
    ClickOutside,
  },

  props: {
    add: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    buttons: {
      type: Boolean,
      default: false,
    },
    field: [Date, String, Number, Array, Object, Boolean],
    stopClickOutside: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      editing: false,
      loadedEditing: false,
    }
  },

  watch: {
    editing() {
      this.$emit('change', this.editing)
    },
  },

  mounted() {
    if (this.add) {
      this.editing = true
    }
  },

  methods: {
    handleClickOutside() {
      if (!this.stopClickOutside) {
        if (this.loadedEditing) {
          this.editing = false
          this.loadedEditing = false
          this.$emit('editEnd')
        } else {
          this.loadedEditing = true
        }
      }
    },

    handleSubmit() {
      this.editing = false
      this.loadedEditing = false
      this.$emit('editEnd')
    },

    switchToEdit() {
      this.editing = true
    },

    switchClickOutsideActive() {
      this.loadedEditing = false
    },
    
    turnEditing(){
      this.editing = !this.readOnly
    },
  },
}
</script>

<style lang="scss">
.tiptap-format {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 16px;
  }
}
</style>
